import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: baseQueryV1,
  tagTypes: ['notifications'],

  endpoints: (builder) => ({
    getNotification: builder.query({
      query: () => 'notifications',
      transformResponse: (res) => res?.data,
      providesTags: ['notifications'],
    }),

    getNotificationByUser: builder.query({
      query: () => 'notifications/user',
      transformResponse: (res) => res?.data,
      providesTags: ['notifications'],
    }),

    markAsRead: builder.mutation({
      query: (ids) => ({
        url: `notifications/markasread`,
        method: 'PUT',
        body: { ids },
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled, getState }) {
        const user = getState().user?.user;
        const method = user?.role === 'ADMIN' ? 'getNotification' : 'getNotificationByUser';

        const patch = dispatch(
          notificationApi.util.updateQueryData(method, undefined, (draft) => {
            draft.forEach((notif) => {
              if (ids.includes(notif.id)) notif.is_read = true;
            });
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),

    deleteNotification: builder.mutation({
      query: (ids) => ({
        url: `notifications/delete`,
        method: 'DELETE',
        body: { ids },
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled, getState }) {
        const user = getState().user?.user;
        const method = user?.role === 'ADMIN' ? 'getNotification' : 'getNotificationByUser';
        const patchResult = dispatch(
          notificationApi.util.updateQueryData(method, undefined, (draft) => {
            for (let i = draft.length - 1; i >= 0; i--) {
              if (ids.includes(draft[i].id)) {
                draft.splice(i, 1);
              }
            }
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetNotificationQuery,
  useGetNotificationByUserQuery,
  useMarkAsReadMutation,
  useDeleteNotificationMutation,
} = notificationApi;
